import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from 'blocks/TextBlock'

import { TextAligning, TextBoxTypes } from 'atoms/TextBox'
import {
  TextBoxCaption3Secondary,
  TextBoxHeadline4,
} from 'atoms/TextBox/Templates'
import { TextBlock, TextBlockAlignItems } from 'blocks/TextBlock'

export interface IShoppingCartPopupHeader extends ITextBlockProps {
  title: ITextBoxProps['title']
  description?: ITextBoxProps['title']
}

export const ShoppingCartPopupHeader = ({
  title,
  description,
  alignItems = TextBlockAlignItems.Center,
  ...rest
}: IShoppingCartPopupHeader) => {
  return (
    <TextBlock alignItems={alignItems} {...rest}>
      <TextBoxHeadline4 alignment={TextAligning.Center} title={title} />
      {description && (
        <TextBoxCaption3Secondary
          alignment={TextAligning.Center}
          title={description}
          font={TextBoxTypes.Button1}
        />
      )}
    </TextBlock>
  )
}
